import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_ID } from '../constants';

/**
 * This interceptor is responsible for adding the x-app-id header to every API request.
 * This header was introduced in an attempt to block all Bot Attack to the backend.
 * It's a simple app identifier that allows us to identify whether a request is coming from the PWA or from an external system.
 */
@Injectable()
export class AppIdInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    try {
      // Clone the request to add the new header.
      const clonedRequest = req.clone({
        setHeaders: {
          'X-App-ID': APP_ID,
        },
      });

      // Pass the cloned request instead of the original request to the next handle
      return next.handle(clonedRequest);
    } catch (error) {
      // If there is an error then just proceed to the next handle
      console.error(
        'Something went wrong in setting the client-id in the request',
        error
      );
      return next.handle(req);
    }
  }
}
